import { FC } from 'react';
import Button from 'src/components/design-system/Button';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';

interface IProps {
  clearFilter: () => void;
  clearSelection?: () => void;
  isClearFiltersDisabled: boolean;
}

const InvoiceGridToolbar: FC<IProps> = ({
  clearFilter,
  clearSelection,
  isClearFiltersDisabled,
}) => (
  <div className="flex w-full gap-2">
    <ClearFilterButton onClick={clearFilter} disabled={isClearFiltersDisabled} />
    {clearSelection && (
      <Button color="info" className="hover:bg-secondary-hover" onClick={clearSelection}>
        Clear Selection
      </Button>
    )}
  </div>
);
export default InvoiceGridToolbar;
